module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-welcome-board-bcfa6e1b40f79a918688a7e889f17f6f.png";